// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__B4eFy","opacity-transition":"success_opacity-transition__0mlxJ"};